import { getImageDpiPath } from './imageTransform';

type Params = {
  src: string;
  width: 100 | 200 | 300 | 600;
};

/**
 * Uses our CDN image transformation service to resize images to specific
 * dimensions, returning `src`, `srcSet`, `width`, `loading`, and `decoding`
 * attributes suitable for spreading onto an `<img>` or `<source>` element.
 */
export function resizeImage({ src, width }: Params) {
  return {
    src: getImageDpiPath(src, width, 1),
    srcSet: `${getImageDpiPath(src, width, 2)} 2x`,
    width,
    loading: 'lazy',
    decoding: 'async',
  } as const;
}
